import React from "react";
import { getBalance } from "../../api"
export function BalanceHistoryPage() {
  const [balances, setBalances] = React.useState([]);
  return (
    <div>

    </div>
  );
}
export function Balances() {
  const [cryptoAmount, setCryptoAmount] = React.useState(0);
  const [fiatAmount, setFiatAmount] = React.useState(0);
  React.useEffect(() => {
    getBalance().then(res => {
      console.log(res);
      setCryptoAmount(res.cryptoAmount);
      setFiatAmount(res.fiatAmount);
    } );
  }, []);

  return (
    <div  style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1rem'}}>
      <div style={{display: 'flex', gap: '0.5rem', justifyContent: 'center', alignItems: 'center'}}>
        <h5 className={"m-0"}><strong>Crypto:</strong> {cryptoAmount} USDT</h5>
        <h5 className={"m-0"}><strong>Fiat:</strong> ${fiatAmount} USD</h5>
      </div>
      {/*<div style={{display: 'flex', gap: '0.5rem', justifyContent: 'center', alignItems: 'center'}}>*/}
      {/*  <button className="btn btn-sm btn-primary" onClick={() => {}}>*/}
      {/*    <i className={"bx bx-plus"}/>*/}
      {/*  </button>*/}
      {/*  <button className="btn  btn-sm  btn-secondary" onClick={() => {}}>*/}
      {/*    <i className={"bx bx-minus"}/>*/}
      {/*  </button>*/}
      {/*</div>*/}

    </div>
  );
}